import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import {
  LuGauge,
  LuUsersRound,
  LuRadioTower,
  LuSettings,
  LuFileCode2,
  LuCreditCard,
  LuBell,
  LuCalendarClock,
  LuMenu,
  LuX,
  LuSmartphone,
  LuGhost,
  LuWallet,
  LuGamepad2,
} from "react-icons/lu";
const img2 = `${process.env.PUBLIC_URL}/rewardedplay.png`;

const menuItems = [
  { to: "/", icon: <LuGauge size={20} />, label: "Dashboard", route: "dashboard" },
  {
    to: "/manage/user/all/data",
    icon: <LuUsersRound size={20} />,
    label: "User Manager",
    route: "user",
  },
  {
    to: "/manage/withdraw",
    icon: <LuWallet size={20} />,
    label: "Withdrawals",
    route: "withdraw",
  },
  {
    to: "/manage/ads/nativeAds/add",
    icon: <LuRadioTower size={20} />,
    label: "Ads Manager",
    route: "ads",
  },
  {
    to: "/manage/withdrawcard",
    icon: <LuCreditCard size={20} />,
    label: "Withdraw Card",
    route: "withdrawcard",
  },
  {
    to: "/manage/cashtask",
    icon: <LuGamepad2 size={20} />,
    label: "Cash Tasks",
    route: "cashtask",
  },
  {
    to: "/manage/promo-apps",
    icon: <LuSmartphone size={20} />,
    label: "Promo Apps",
    route: "promo-apps",
  },
  {
    to: "/manage/snap-pixel",
    icon: <LuGhost size={20} />,
    label: "Snap Pixel",
    route: "snap-pixel",
  },
  {
    to: "/controller",
    icon: <LuSettings size={20} />,
    label: "Controller",
    route: "controller",
  },
  {
    to: "/manage/notification/send",
    icon: <LuBell size={20} />,
    label: "Notifications",
    route: "notification",
  },
  {
    to: "/manage/notification/templates",
    icon: <LuCalendarClock size={20} />,
    label: "Scheduled",
    route: "notification",
  },
  {
    to: "/manage/api-docs",
    icon: <LuFileCode2 size={20} />,
    label: "API Docs",
    route: "api-docs",
  },
];

const Navbar1 = () => {
  const [isMobileNavOpen, setIsMobileNavOpen] = useState(false);
  const location = useLocation();
  const [onSelect, setOnSelect] = useState([]);

  const toggleMobileNav = () => setIsMobileNavOpen((s) => !s);

  useEffect(() => {
    const pathArray = location.pathname.split("/");
    setOnSelect(pathArray[1] === "" ? ["dashboard"] : pathArray);
    setIsMobileNavOpen(false);
  }, [location.pathname]);

  const isActive = (route) => onSelect.includes(route);

  const Brand = () => (
    <div className="flex items-center gap-2.5 h-16 px-5 border-b border-main-border shrink-0">
      <img
        src={img2}
        alt="Rewarded Play"
        className="w-9 h-9 rounded-xl object-contain bg-white ring-1 ring-brand-teal/30 shadow-sm shrink-0"
      />
      <div className="flex flex-col leading-none">
        {/* Matches the app logo lockup: "Rewarded" dark, "Play" in the brand violet → light violet */}
        <span className="font-extrabold text-[17px] text-main-font tracking-tight whitespace-nowrap">
          Rewarded <span className="text-gradient-teal">Play</span>
        </span>
        <span className="text-[10px] font-semibold tracking-[0.28em] text-main-subfont uppercase mt-0.5">
          Admin Panel
        </span>
      </div>
    </div>
  );

  const NavList = ({ onItemClick }) => (
    <ul className="space-y-1.5">
      {menuItems.map((item) => {
        const active = isActive(item.route);
        return (
          <li key={item.route}>
            <Link
              to={item.to}
              onClick={onItemClick}
              className={`flex items-center gap-3 px-3.5 py-2.5 rounded-xl text-sm font-medium transition-all duration-200 ${
                active
                  ? "bg-teal-500/15 text-brand-teal"
                  : "text-main-subfont hover:bg-teal-500/10 hover:text-main-font"
              }`}
            >
              <span className="shrink-0">{item.icon}</span>
              <span>{item.label}</span>
            </Link>
          </li>
        );
      })}
    </ul>
  );

  return (
    <>
      {/* DESKTOP SIDEBAR (always expanded) */}
      <aside className="hidden md:flex flex-col fixed top-0 left-0 z-50 h-screen w-56 bg-night-900/80 backdrop-blur-xl border-r border-brand-teal/12 shadow-[8px_0_40px_-20px_rgba(0,0,0,0.7)]">
        <Brand />
        <nav className="flex-1 overflow-y-auto px-3 py-5">
          <NavList />
        </nav>
      </aside>

      {/* MOBILE NAV */}
      <div className="md:hidden">
        <button
          onClick={toggleMobileNav}
          className="fixed top-3 left-3 z-[120] bg-gradient-to-r from-teal-500 to-cyan-500 text-white p-2 rounded-xl shadow-lg shadow-teal-500/30"
        >
          {isMobileNavOpen ? <LuX size={24} /> : <LuMenu size={24} />}
        </button>

        <div
          className={`fixed inset-0 z-[100] bg-black/50 backdrop-blur-sm transition-opacity duration-300 ${
            isMobileNavOpen ? "opacity-100 visible" : "opacity-0 invisible"
          }`}
          onClick={toggleMobileNav}
        />

        <div
          className={`fixed top-0 left-0 h-full w-72 z-[110] bg-night-900/95 backdrop-blur-xl shadow-2xl transform transition-transform duration-300 ${
            isMobileNavOpen ? "translate-x-0" : "-translate-x-full"
          }`}
        >
          <Brand />
          <nav className="px-3 py-5">
            <NavList onItemClick={toggleMobileNav} />
          </nav>
        </div>
      </div>
    </>
  );
};

export default Navbar1;
